export const SITE_ORIGIN = "https://modernfenceinstall.com";
export const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;

/** Public /order is deliberately indexable; only private/receipt paths are excluded. */
export function isNoindexPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0]?.replace(/\/+$/, "") || "/";
  return /^(?:\/(?:admin|account|publisher|auth|pay-balance|checkout|checkout-attempts)(?:\/|$)|\/order\/success(?:\/|$)|\/thanks(?:\/|$))/.test(pathname);
}

export function pageHead(title: string, description: string, path?: string, noindex = false, type = "website") {
  const fullTitle = title.includes("Modern Fence Install") ? title : `${title} | Modern Fence Install`;
  const canonical = path ? `${SITE_ORIGIN}${path}` : undefined;
  return {
    meta: [
      { title: fullTitle },
      { name: "description", content: description },
      { property: "og:title", content: fullTitle },
      { property: "og:description", content: description },
      { property: "og:type", content: type },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: noindex ? "noindex, follow" : "index, follow" },
      ...(canonical ? [{ property: "og:url", content: canonical }] : []),
    ],
    links: canonical ? [{ rel: "canonical", href: canonical }] : [],
  };
}

export const unavailableHead = () => pageHead("Page unavailable", "This page could not be found or is temporarily unavailable.", undefined, true);

export function hasUnavailableMatch(matches: readonly { status: string; _notFound?: boolean }[]) {
  return matches.some(match => match._notFound || match.status === "notFound" || match.status === "error");
}

/** A service area is not a business address or a physical branch. */
export function serviceAreaSchema(url: string, name: string, description: string, area: string, areaType = "AdministrativeArea") {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${url}#service`,
    name,
    description,
    url,
    provider: { "@id": ORGANIZATION_ID },
    areaServed: { "@type": areaType, name: area },
  };
}